import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '../../utils/object-utils';
import './analytics-filter-menu.scss';
import { getDateToFilterByParameter, getDateRangeParameters, getShowLatestData } from '../../store/actions/utils/url-utils';
import { getFormattedDate } from '../../utils/date-utils';
import CloseIcon from '../icons/CloseIcon';
import CheckboxInput from '../inputs/CheckboxInput';

class AnalyticsFilterMenu extends Component {
    constructor(props) {
        super(props);
        const dateToFilterByParameter = getDateToFilterByParameter();
        const dateRangeParameters = getDateRangeParameters();
        const filters = {};

        if (!isEmpty(dateToFilterByParameter)) {
            filters[getFormattedDate(dateToFilterByParameter)] = true;
        }

        if (!isEmpty(dateRangeParameters)) {
            filters[getFormattedDate(dateRangeParameters.from)] = true;
            filters[getFormattedDate(dateRangeParameters.to)] = true;
        }

        this.state = { toggleMenu: false, filters };
        this.handleToggleMenuClick = this.handleToggleMenuClick.bind(this);
        this.handleToggleDisplayLatestData = this.handleToggleDisplayLatestData.bind(this);
        this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
        this.handleFiltersChanged = this.handleFiltersChanged.bind(this);
        this.handleClearFiltersClick = this.handleClearFiltersClick.bind(this);
        this.getDisplayLatestDataValue = this.getDisplayLatestDataValue.bind(this);
        this.displayMenuToggleButton = this.displayMenuToggleButton.bind(this);
        this.displayMenu = this.displayMenu.bind(this);
        this.displayFilteredItems = this.displayFilteredItems.bind(this);
    }

    handleToggleMenuClick() {
        this.setState((prevState) => {
            return {
                toggleMenu: !prevState.toggleMenu
            };
        });
    }

    handleToggleDisplayLatestData(displayDataValue) {
        const { onDisplayLatestDataClick } = this.props;
        this.setState((prevState) => {
            return {
                ...prevState,
                filters: {}
            };
        }, () => {
            onDisplayLatestDataClick(!displayDataValue);
        });
    }

    handleMenuItemClick(menuItem) {
        this.setState((prevState) => {
            return {
                ...prevState,
                filters: {
                    ...prevState.filters,
                    [menuItem.text]: !prevState.filters[menuItem.text]
                }
            };
        }, this.handleFiltersChanged);
    }

    handleFiltersChanged() {
        const { onFilterByDateClick, onFilterByRangeClick, menuData } = this.props;
        const { filters } = this.state;

        if (isEmpty(filters)) {
            return;
        }
        const filterKeys = Object.keys(filters);
        const keysToFilterBy = filterKeys.filter((filterKey) => filters[filterKey]);

        if (isEmpty(keysToFilterBy)) {
            this.handleClearFiltersClick();
            return;
        }

        const filteredItems = menuData.filter((item) => { return keysToFilterBy.includes(item.text); });

        if (filteredItems.length === 1) {
            onFilterByDateClick(filteredItems[0].value.getTime());
            return;
        }

        if (filteredItems.length >= 2) {
            const fromDate = filteredItems[filteredItems.length - 1].value.getTime();
            const toDate = filteredItems[0].value.getTime();
            onFilterByRangeClick({ from: fromDate, to: toDate });
        }
    }

    handleClearFiltersClick() {
        const { onClearFiltersClick } = this.props;
        this.setState((prevState) => {
            return {
                ...prevState,
                filters: {}
            };
        }, onClearFiltersClick);
    }

    displayMenuToggleButton() {
        const {
            buttonText,
            menuData
        } = this.props;

        if (isEmpty(menuData)) {
            return null;
        }

        return <button className="button-base-root button-root button-contained button-contained-secondary button-contained-size-small"
            onClick={this.handleToggleMenuClick}
            tabIndex="0"
            type="button"
            aria-haspopup="true"
            aria-owns="simple-menu">
            <span >{buttonText}</span>
        </button>;
    }


    getDisplayLatestDataValue() {
        return getShowLatestData();
    }

    displayMenu() {
        const { toggleMenu, filters } = this.state;
        const { menuData } = this.props;

        if (!toggleMenu || isEmpty(menuData)) {
            return null;
        }

        return <div className='analytics-menu-container' tabIndex="-1">
            <ul className='analytics-component analytics-menu' role="menu" tabIndex="-1">
                <div className='analytics-clear-filters' onClick={this.handleClearFiltersClick}>
                    <span className='analytics-label'> {'Clear Filters'}</span>
                </div>
                <div className='analytics-close-menu' >
                    <CloseIcon onClick={this.handleToggleMenuClick}></CloseIcon>
                </div>
                <li className={'analytics-menu-list-item'}
                    tabIndex="0"
                    role="menuitem"
                    aria-disabled="false">
                    <CheckboxInput
                        onChange={this.handleToggleDisplayLatestData}
                        checkedValue={this.getDisplayLatestDataValue()}
                        inputItem={this.getDisplayLatestDataValue()}
                        inputText={'Display latest data'}
                    ></CheckboxInput>
                </li>
                {this.displayFilteredItems(menuData, filters)}
            </ul>
        </div>;
    }

    displayFilteredItems(menuData, filters) {
        return menuData.map((menuItem, index) => {
            return (
                <li key={index}
                    className={'analytics-menu-list-item'}
                    tabIndex="0"
                    role="menuitem"
                    aria-disabled="false">
                    <CheckboxInput
                        onChange={this.handleMenuItemClick}
                        inputItem={menuItem}
                        checkedValue={filters[menuItem.text]}
                        inputText={menuItem.text}
                    ></CheckboxInput>
                </li>);
        });
    }

    render() {
        return (
            <Fragment>
                {this.displayMenuToggleButton()}
                {this.displayMenu()}
            </Fragment>
        );
    }
}

AnalyticsFilterMenu.propTypes = {
    buttonText: PropTypes.string,
    menuData: PropTypes.array,
    onMenuButtonClick: PropTypes.func,
    onFilterByDateClick: PropTypes.func,
    onFilterByRangeClick: PropTypes.func,
    onDisplayLatestDataClick: PropTypes.func,
    onClearFiltersClick: PropTypes.func,
};

export default AnalyticsFilterMenu;
